import DepositRedirectSystemClass from './DepositRedirectSystemClass';


export default class DepositRedirectNewTabSystem extends DepositRedirectSystemClass {
    newTab = (): boolean => true;
}
